"use client";

import { useCallback } from "react";
import { cookieLogger } from "../utils/logger";

declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay: () => void;
    };
    Optanon?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export default function ManageCookiesLink() {
  const handleClick = useCallback((_e: React.MouseEvent<HTMLButtonElement>) => {
    // Try OneTrust API first (v2)
    if (window.OneTrust?.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay();
      return;
    }
    // Fallback to Optanon API (v1)
    if (window.Optanon?.ToggleInfoDisplay) {
      window.Optanon.ToggleInfoDisplay();
      return;
    }
    // If APIs aren't available, OneTrust should handle clicks on elements with this class
    if (process.env.NODE_ENV === "development") {
      cookieLogger.warn("onetrust_api_not_available", {
        message:
          "Make sure NEXT_PUBLIC_ONETRUST_DOMAIN_SCRIPT_ID is set and OneTrust script is loaded",
      });
    }
    // Let the default click behavior proceed - OneTrust should intercept it via the class
  }, []);

  return (
    <button
      type="button"
      className="ot-sdk-show-settings"
      onClick={handleClick}
      style={{
        background: "none",
        border: "none",
        color: "var(--zds-colors-link-primary, #0066cc)",
        textDecoration: "underline",
        cursor: "pointer",
        padding: 0,
        fontSize: "14px",
        fontFamily: "inherit",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = "0.8";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
    >
      Manage cookies
    </button>
  );
}
